import { deleteRequest } from 'utils/api/apiRequest'

export type DeleteLikePayload = {
  post: number
}

export const deleteLike = (data: DeleteLikePayload) => deleteRequest(`/social-wall/posts/likes`, { data })
